import React from "react";
import { Box, Typography, Button, useTheme, Divider, Grid } from "@mui/material";

const OptionsPopup = ({ open, options }) => {
  const theme = useTheme();
  const containerStyle = {
    backgroundColor: "#D0D5DE",
    color: "#717273",
    borderRadius: "10px",
    position: "fixed",
    right: "8px",
    top: 40,
    minWidth: "40vw",
    maxWidth: "80vw",
    overflow: "auto",
    zIndex: `${theme.zIndex.drawer + 2} !important`,
    px: 2,
  };
  return (
    open && (
      <Box sx={containerStyle}>
        <Typography sx={{ py: 0.5 }}>Options</Typography>
        <Divider />
        <Grid container>
          {options.map((o) => (
            <Grid key={o.label} item xs={12} sx={{ display: "flex", alignItems: "center" }}>
              <Button variant="text" endIcon={o.icon} onClick={o.onClick} sx={{ color: "#717273", width: "100%", px: 0 }} disabled={o.disabled}>
                {o.label}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
    )
  );
};

export default OptionsPopup;
